<template>
    <div>
        <h2 class="ssv-title__secondary">Distributor</h2>
        <ssv-order-distributor-form v-bind="$props" ref="distributorForm"/>
    </div>
</template>

<script>
    import SsvOrderDistributorForm from './DistributorForm';

    export default {
        name: 'SsvOrderDistributorContainer',
        components: {
            SsvOrderDistributorForm,
        },
        methods: {
            validate() {
                this.$refs.distributorForm.validate();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/distributor/DistributorContainer.vue